import { observer } from 'mobx-react-lite';
import { getFirstLineTitle, getSecondLineTextAndTitle } from '../utils/getAttachmentInfo';
import { AttachmentViewState } from 'owa-attachment-data';
import { AttachmentDocInfoViewBase } from 'owa-attachment-common-view';
import { AttachmentModel } from 'owa-attachment-model-store';
import * as React from 'react';

export interface AttachmentDocInfoProps {
    attachmentViewState: AttachmentViewState;
    attachment: AttachmentModel;
    firstLineStyle: string;
    secondLineStyle: string;
    isShortDocView: boolean;
    highlightAttachmentName: (ref: HTMLDivElement) => void;
}

export default observer(function AttachmentDocInfoView(props: AttachmentDocInfoProps) {
    const firstLineTitle = getFirstLineTitle(props.attachmentViewState, props.attachment);
    const secondLine = getSecondLineTextAndTitle(props.attachmentViewState, props.attachment);
    return (
        <AttachmentDocInfoViewBase
            firstLineStyle={props.firstLineStyle}
            firstLineText={props.attachment.model.Name}
            firstLineTitle={firstLineTitle}
            highlightAttachmentName={props.highlightAttachmentName}
            isShortDocView={props.isShortDocView}
            secondLineStyle={props.secondLineStyle}
            secondLineText={secondLine.text}
            secondLineTitle={secondLine.title ? secondLine.title : firstLineTitle}
        />
    );
});
